import { Outlet } from 'react-router-dom';
import { SiteHeader } from '@/components/site/SiteHeader';
import { SiteFooter } from '@/components/site/SiteFooter';
import { LanguageSuggestionBanner } from '@/components/site/LanguageSuggestionBanner';

export function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-vyxora-bg-dark text-vyxora-text-light">
      <SiteHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
      <LanguageSuggestionBanner />
    </div>
  );
}
